/* ==========================================================================
   Couvision B2B - snel bestellen vanuit de lijst.

   Een regel is [data-b2b-row]. Een klik op [data-b2b-add] leest het
   aantalveld [data-b2b-qty], post naar /cart/add.js en meldt het resultaat
   IN die regel ([data-b2b-status]). Geen paginawissel, geen verlies van de
   rest van de lijst.

   De winkelwagenteller en het ophalen van /cart.js horen bij couvision.js
   (window.__cvCartCount). Die wordt hier aangeroepen, niet nagebouwd: er
   hoort maar een winkelwagenmechaniek in dit thema te zitten.

   Alle klantteksten komen uit data-attributen op de regel, zodat ze via
   locale-sleutels vertaalbaar blijven. In dit bestand staat daarom geen
   enkele vaste zin.

   Verwachte opmaak per regel (de sectie levert dit, niet dit bestand):

     <tr data-b2b-row
         data-b2b-variant="41234567890"
         data-b2b-busy-text="{{ 'b2b.regel.bezig' | t }}"
         data-b2b-ok-text="{{ 'b2b.regel.toegevoegd' | t: count: '%d' }}"
         data-b2b-error-text="{{ 'b2b.regel.mislukt' | t }}"
         data-b2b-qty-error-text="{{ 'b2b.regel.aantal_ongeldig' | t }}">
       <td><input type="number" data-b2b-qty value="1"
                  min="{{ variant.quantity_rule.min }}"
                  step="{{ variant.quantity_rule.increment }}"></td>
       <td>
         <button type="button" data-b2b-add>{{ 'b2b.regel.bestellen' | t }}</button>
         <span data-b2b-status hidden></span>
       </td>
     </tr>

   Toelichting bij de attributen:
   - de variant-id mag ook op de knop staan (data-b2b-add="41234567890") of
     als <input name="id"> in de regel;
   - %d in de gelukt-tekst wordt vervangen door het bestelde aantal. Ook
     {{ count }} en {{ aantal }} worden herkend, mocht de sectie het
     placeholder-teken laten staan;
   - [data-b2b-status] mag ontbreken; dan maakt dit script er zelf een, want
     een fout die nergens past mag niet onzichtbaar blijven;
   - data-b2b-reset-ms (optioneel) wist de melding na zoveel milliseconden.
     Zonder dat attribuut blijft de melding staan tot het aantal verandert.

   Dit bestand hoort ingeladen te worden naast couvision.js, bijvoorbeeld
   met: <script src="{{ 'b2b-quickorder.js' | asset_url }}" defer></script>
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Kleine hulpjes ---------------------------------------------------- */

  function regelVan(el) {
    return el && el.closest ? el.closest('[data-b2b-row]') : null;
  }

  function getal(waarde, terugval) {
    var n = parseInt(waarde, 10);
    return isNaN(n) ? terugval : n;
  }

  /* De tekst komt altijd van de regel. Ontbreekt het attribuut, dan geven we
     een lege string terug en valt de aanroeper terug op iets anders (de reden
     van Shopify, of alleen de toestand op de regel). Zelf een zin verzinnen
     zou een onvertaalbare tekst in de winkel zetten. */
  function tekst(regel, naam, aantal) {
    var t = regel.getAttribute('data-b2b-' + naam + '-text');
    if (!t) return '';
    if (aantal === null || aantal === undefined) return t;
    return t.replace(/%d|\{\{\s*(?:count|aantal)\s*\}\}/g, String(aantal));
  }

  /* ---- Meldingsplek per regel -------------------------------------------- */

  function statusVan(regel) {
    var el = regel.querySelector('[data-b2b-status]');
    if (!el) {
      el = document.createElement('span');
      el.setAttribute('data-b2b-status', '');
      var knop = regel.querySelector('[data-b2b-add]');
      if (knop && knop.parentNode) knop.parentNode.appendChild(el);
      else regel.appendChild(el);
    }
    if (!el.getAttribute('role')) el.setAttribute('role', 'status');
    if (!el.getAttribute('aria-live')) el.setAttribute('aria-live', 'polite');
    return el;
  }

  /* toestand is '' (neutraal), 'bezig', 'ok' of 'fout'. De toestand staat op
     de regel en op de meldingsplek, zodat de stylesheet er een kleur of icoon
     aan kan hangen ook als de tekst kort is of ontbreekt. */
  function meld(regel, toestand, boodschap) {
    var el = statusVan(regel);
    if (toestand) {
      regel.setAttribute('data-b2b-state', toestand);
      el.setAttribute('data-b2b-state', toestand);
    } else {
      regel.removeAttribute('data-b2b-state');
      el.removeAttribute('data-b2b-state');
    }
    el.textContent = boodschap || '';
    if (!toestand && !boodschap) el.setAttribute('hidden', '');
    else el.removeAttribute('hidden');
  }

  function verloopMelding(regel) {
    var ms = getal(regel.getAttribute('data-b2b-reset-ms'), 0);
    if (regel.__cvB2bTimer) {
      clearTimeout(regel.__cvB2bTimer);
      regel.__cvB2bTimer = null;
    }
    if (ms > 0) {
      regel.__cvB2bTimer = setTimeout(function () { meld(regel, '', ''); }, ms);
    }
  }

  /* ---- Aantal lezen en binnen de bestelregels houden ---------------------- */

  /* quantity_rule van Shopify staat standaard op min 1, increment 1, geen
     maximum. Staan die als min/step/max op het veld, dan corrigeren we het
     ingetikte aantal voor we posten: dat scheelt een afgewezen verzoek. De
     correctie wordt in het veld teruggeschreven, zodat de klant ziet wat er
     werkelijk besteld wordt. */
  function aantalVan(regel) {
    var veld = regel.querySelector('[data-b2b-qty]');
    if (!veld) return { aantal: 1, veld: null, geldig: true };

    var ruw = String(veld.value === null || veld.value === undefined ? '' : veld.value).trim();
    var n = parseInt(ruw, 10);
    if (!ruw || isNaN(n) || n < 1) return { aantal: 0, veld: veld, geldig: false };

    var min = getal(veld.getAttribute('min') || regel.getAttribute('data-b2b-min'), 1);
    if (min < 1) min = 1;
    var stap = getal(veld.getAttribute('step') || regel.getAttribute('data-b2b-step'), 1);
    if (stap < 1) stap = 1;
    var max = getal(veld.getAttribute('max') || regel.getAttribute('data-b2b-max'), 0);

    if (n < min) n = min;
    if (stap > 1) {
      var rest = (n - min) % stap;
      if (rest !== 0) n = n + (stap - rest);
    }
    if (max > 0 && n > max) {
      n = max;
      if (stap > 1) {
        var over = (n - min) % stap;
        if (over !== 0) n = n - over;
      }
      if (n < min) n = min;
    }

    if (String(n) !== ruw) veld.value = n;
    return { aantal: n, veld: veld, geldig: true };
  }

  /* ---- Variant-id ophalen ------------------------------------------------ */

  function variantVan(regel, knop) {
    var id = getal(regel.getAttribute('data-b2b-variant'), 0);
    if (!id && knop) id = getal(knop.getAttribute('data-b2b-add'), 0);
    if (!id) {
      var verborgen = regel.querySelector('[data-b2b-variant-input], input[name="id"]');
      if (verborgen) id = getal(verborgen.value, 0);
    }
    return id > 0 ? id : 0;
  }

  /* ---- Knopstatus -------------------------------------------------------- */

  function bezig(knop, aan) {
    knop.__cvB2bBezig = !!aan;
    if (aan) {
      knop.setAttribute('aria-disabled', 'true');
      knop.setAttribute('data-b2b-busy', '');
      if ('disabled' in knop) knop.disabled = true;
    } else {
      knop.removeAttribute('aria-disabled');
      knop.removeAttribute('data-b2b-busy');
      if ('disabled' in knop) knop.disabled = false;
    }
  }

  /* ---- Teller bijwerken -------------------------------------------------- */

  function tellerBijwerken() {
    if (typeof window.__cvCartCount === 'function') {
      try { return window.__cvCartCount(); } catch (e) { /* teller mag de bestelling niet breken */ }
    }
    return null;
  }

  /* ---- Toevoegen --------------------------------------------------------- */

  function voegToe(regel, knop) {
    var q = aantalVan(regel);
    if (!q.geldig) {
      meld(regel, 'fout', tekst(regel, 'qty-error') || tekst(regel, 'error'));
      if (q.veld) {
        q.veld.focus();
        try { q.veld.select(); } catch (e) { /* select bestaat niet op elk veldtype */ }
      }
      return;
    }

    var id = variantVan(regel, knop);
    if (!id) {
      meld(regel, 'fout', tekst(regel, 'error'));
      if (window.console && console.warn) {
        console.warn('[b2b] regel zonder bruikbare variant-id, verwacht data-b2b-variant', regel);
      }
      return;
    }

    bezig(knop, true);
    meld(regel, 'bezig', tekst(regel, 'busy'));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: q.aantal }] })
    }).then(function (res) {
      if (!res.ok) {
        /* Shopify zet de leesbare reden (uitverkocht, boven het maximum) in
           het veld description. Die reden is preciezer dan onze eigen zin en
           komt in de taal van de winkel, dus die wint. */
        return res.json().catch(function () { return null; }).then(function (j) {
          var reden = j && (j.description || j.message);
          meld(regel, 'fout', reden || tekst(regel, 'error'));
          verloopMelding(regel);
        });
      }
      return res.json().catch(function () { return null; }).then(function () {
        meld(regel, 'ok', tekst(regel, 'ok', q.aantal));
        verloopMelding(regel);
        document.dispatchEvent(new CustomEvent('cv:winkelwagen-bijgewerkt', {
          detail: { id: id, aantal: q.aantal, regel: regel }
        }));
        return tellerBijwerken();
      });
    }).catch(function () {
      /* Geen verbinding of een afgebroken verzoek. Doorsturen naar /cart zou
         de ingevulde lijst weggooien, dus blijft de klant staan waar hij staat
         en leest hij in zijn eigen regel dat het niet gelukt is. */
      meld(regel, 'fout', tekst(regel, 'error'));
      verloopMelding(regel);
    }).finally(function () {
      bezig(knop, false);
    });
  }

  /* ---- Luisteren op documentniveau --------------------------------------- */
  /* Alles via delegatie, zodat regels die later in de pagina komen (filteren,
     doorladen, een sectie die opnieuw rendert) vanzelf meedoen. Elke regel
     heeft zijn eigen knop, veld en melding en werkt dus los van de andere. */

  document.addEventListener('click', function (e) {
    var knop = e.target.closest ? e.target.closest('[data-b2b-add]') : null;
    if (!knop) return;
    var regel = regelVan(knop);
    if (!regel) return;

    /* Ook een submit-knop mag hier niet de pagina verversen. */
    e.preventDefault();

    /* Al bezig, of door de opmaak uitgezet (uitverkocht): niets doen. Zo kan
       dubbelklikken de bestelling niet twee keer versturen. */
    if (knop.__cvB2bBezig) return;
    if (knop.getAttribute('aria-disabled') === 'true') return;

    voegToe(regel, knop);
  });

  /* Enter in het aantalveld hoort te bestellen. Zonder dit verstuurt de
     browser het omliggende formulier en verlies je de rest van de lijst. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var veld = e.target.closest ? e.target.closest('[data-b2b-qty]') : null;
    if (!veld) return;
    var regel = regelVan(veld);
    if (!regel) return;
    var knop = regel.querySelector('[data-b2b-add]');
    if (!knop) return;
    e.preventDefault();
    knop.click();
  });

  /* Een oude melding hoort niet bij een nieuw aantal: "5 toegevoegd" naast
     het getal 10 is een onwaarheid op het scherm. Zodra het aantal verandert
     gaat de melding weg. */
  function meldingWissen(e) {
    var veld = e.target.closest ? e.target.closest('[data-b2b-qty]') : null;
    if (!veld) return;
    var regel = regelVan(veld);
    if (!regel) return;
    if (regel.getAttribute('data-b2b-state')) meld(regel, '', '');
  }
  document.addEventListener('input', meldingWissen);
  document.addEventListener('change', meldingWissen);
}());
